import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ComputerequipmentService {
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/ComputerEquipment/';

  insertcomputerequipment(data) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'insertcomputerequipment', data)
  }

  getcomputerequipment(id) {
    debugger
    return this.http.get(this.apiUrl + 'getcomputerequipment?id=' + id)
  }
  getcomputerequipmentLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'getcomputerequipmentLY?id=' + id)
  }

  getTangableData(id) {
    debugger
    return this.http.get(this.apiUrl + 'gettangable?id=' + id)
  }
}
